import React from "react"
import { Menu } from '@mui/material'
import { MoreVert } from '@mui/icons-material'

export default function MenuBar({ setAnchorEl, anchorEl, menuId, children, color = "icon" }) {
    const open = Boolean(anchorEl)

    const handleClose = (e) => {
        e.stopPropagation()
        setAnchorEl(null)
      }

    const projectOptions = (e) => {
        e.stopPropagation()
        setAnchorEl(e.currentTarget)
    }

    return (
        <>
            <MoreVert onClick={projectOptions} color={color} />
            <Menu
                id={menuId}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
                {children }
            </Menu>
        </>
    )
}